import React from "react";

import Tag from "../../components/Tag";

const TagList = ({ tags, onClick }) => {
  return (
    <div>
      {tags.map(t => {
        return (
          <span key={t.tag_id} style={{ paddingLeft: 5 }}>
            <a
              href="/"
              onClick={e => {
                e.preventDefault();
                onClick(t.tag_id);
              }}
            >
              <Tag text={t.tag_name} />
            </a>
          </span>
        );
      })}
    </div>
  );
};

export default TagList;



// WEBPACK FOOTER //
// ./src/pages/Tags/TagList.jsx